// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3gN-v","buttons":"RemoveExpirationActionButtons_buttons__3Nphi"};